
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomumbaionlinecabbooking() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Online Cab Booking',
        heading: 'Meghana Cab : Pune to Mumbai Online Cab Booking  ',
        headingDescription: 'Meghana Cab offers transparent and affordable Pune to Mumbai Online Cab Booking, ensuring value for money without compromising on comfort and safety. Whether you are traveling solo or in a group, our fleet includes Hatchbacks, Sedans, SUVs, Innova Crysta, and Tempo Travellers to suit every budget and need. Enjoy fixed pricing with no hidden charges, professional drivers, clean vehicles, and on-time service. Our Pune to Mumbai route covers major pickup points and provides door-to-door convenience. Book with Meghana Cab today for a reliable journey and know your Pune to Mumbai Taxi Fare upfront—no surprises, just smooth travel.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [
    {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

"services": [
    {
        "name": "Online Booking Cab Pune to Mumbai",
        "description": "Book your cab online from Pune to Mumbai with ease using our reliable platform. Whether it's a last-minute trip or a pre-planned journey, our online system offers instant confirmation, vehicle options, fare transparency, and real-time customer support to ensure a stress-free experience."
    },
    {
        "name": "Book Cab Online Pune to Mumbai",
        "description": "Skip the hassle of phone calls and queues—book your Pune to Mumbai cab online in just a few clicks. Select from sedans, SUVs, or premium vehicles, all with verified drivers and competitive pricing. Ideal for solo travelers, families, and business professionals."
    },
    {
        "name": "Fast Cab Reservation Pune to Mumbai",
        "description": "Need a quick cab booking for your Pune to Mumbai travel? Our fast reservation system helps you secure your ride in seconds. With live vehicle availability and no long wait times, this service is perfect for urgent travel plans or tight schedules."
    },
    {
        "name": "One Way Online Cab Pune to Mumbai",
        "description": "Save money and time with our one-way online cab booking from Pune to Mumbai. Ideal for travelers who don’t require a return trip, this service offers affordable pricing, clean cars, and professional drivers ready for door-to-door service."
    },
    {
        "name": "Round Trip Online Booking Pune Mumbai",
        "description": "Planning a round trip from Pune to Mumbai and back? Use our easy online booking system to reserve both legs of your journey at once. Enjoy discounted round-trip rates, well-maintained cars, and prompt service tailored for your schedule."
    },
    {
        "name": "24/7 Cab Booking Site Pune to Mumbai",
        "description": "Our website is open 24/7 so you can book a cab from Pune to Mumbai anytime—day or night. Perfect for early-morning airport runs, late-night returns, or last-minute bookings, we guarantee round-the-clock availability and support."
    },
    {
        "name": "App Booking Cab Pune to Mumbai",
        "description": "Download our mobile app for seamless Pune to Mumbai cab booking on the go. Track your cab, manage payments, receive live updates, and access customer support—all from your smartphone, anytime and anywhere."
    },
    {
        "name": "Secure Online Taxi Booking Pune Mumbai",
        "description": "Book your taxi from Pune to Mumbai with confidence using our secure platform. We offer encrypted transactions, verified drivers, and complete fare transparency to make sure your booking experience is not only smooth but also safe."
    },
    {
        "name": "Sedan Booking Online Pune to Mumbai",
        "description": "Reserve a comfortable sedan online for your Pune to Mumbai journey. Ideal for professionals, couples, or solo travelers who prefer a quiet, smooth ride. AC, clean interiors, and polite chauffeurs included."
    },
    {
        "name": "SUV Online Booking Pune to Mumbai",
        "description": "Book an SUV online for spacious and comfortable travel from Pune to Mumbai. Our SUVs are great for family travel, group outings, or luggage-heavy trips. Choose from top-rated models with experienced drivers."
    },
    {
        "name": "Quick Cab Online Booking Pune Mumbai Route",
        "description": "Get on the road faster with our quick online cab booking for the Pune to Mumbai route. Just enter your trip details, select a vehicle, and confirm—your ride will be on the way in minutes. A great option for spontaneous travelers and urgent trips."
    },
    {
        "name": "Chauffeur Booking Pune Mumbai Cab",
        "description": "Prefer a professional behind the wheel? Book a chauffeur-driven cab online for your Pune to Mumbai journey. Our trained, courteous drivers ensure a smooth, safe, and premium intercity travel experience."
    },
    {
        "name": "Private Taxi Online Booking Pune to Mumbai",
        "description": "Book a private taxi online from Pune to Mumbai for a peaceful and personal travel experience. No ride-sharing, no delays—just door-to-door comfort in your own space, with vetted drivers and timely service."
    },
    {
        "name": "Budget Online Cab Hire Pune Mumbai",
        "description": "Need an affordable travel solution? Our budget online cab hire lets you book low-cost vehicles for the Pune to Mumbai route without compromising safety or cleanliness. A great fit for students, frequent travelers, and families on a budget."
    },
    {
        "name": "Instant Booking Cab Pune to Mumbai",
        "description": "Get your Pune to Mumbai cab booked instantly with our real-time system. Perfect for emergencies or impromptu plans, this feature ensures that a cab is available at your fingertips within minutes of booking."
    }
],
"tableData": [
    ["Online Booking Cab Pune to Mumbai", "Book Cab Online Pune to Mumbai"],
    ["Fast Cab Reservation Pune to Mumbai", "One Way Online Cab Pune to Mumbai"],
    ["Round Trip Online Booking Pune Mumbai", "24/7 Cab Booking Site Pune to Mumbai"],
    ["App Booking Cab Pune to Mumbai", "Secure Online Taxi Booking Pune Mumbai"],
    ["Sedan Booking Online Pune to Mumbai", "SUV Online Booking Pune to Mumbai"],
    ["Quick Cab Online Booking Pune Mumbai Route", "Chauffeur Booking Pune Mumbai Cab"],
    ["Private Taxi Online Booking Pune to Mumbai", "Budget Online Cab Hire Pune Mumbai"],
    ["Instant Booking Cab Pune to Mumbai", ""]
],







"whychoose": [
    {
        "WhyChooseheading": "Seamless Online Cab Booking Experience",
        "WhyChoosedescription": "Book your cab from Pune to Mumbai effortlessly with our user-friendly online platform. Whether you’re planning a last-minute trip or scheduling your journey in advance, our booking system is fast, reliable, and accessible 24/7 from any device."
    },
    {
        "WhyChooseheading": "Instant Confirmation with Real-Time Availability",
        "WhyChoosedescription": "No more waiting or uncertainty. When you book online, you receive immediate confirmation along with vehicle details, driver contact information, and estimated arrival time. Our real-time availability ensures you're always matched with the right cab instantly."
    },
    {
        "WhyChooseheading": "Multiple Payment Options and Secure Transactions",
        "WhyChoosedescription": "Pay the way you prefer—our online booking platform supports UPI, credit/debit cards, net banking, and wallets. All transactions are encrypted and secure, ensuring your payment data is protected while giving you flexibility and convenience."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles to Suit Every Traveler",
        "WhyChoosedescription": "From budget-friendly hatchbacks and spacious sedans to luxury SUVs and tempo travelers, choose the perfect vehicle for your Pune to Mumbai journey. Each booking option comes with clear pricing and features, helping you make the best choice."
    },
    {
        "WhyChooseheading": "Track Your Cab in Real Time After Booking",
        "WhyChoosedescription": "Once your booking is confirmed, track your cab’s location in real-time through our system. Stay informed about driver arrival times, route updates, and expected travel duration to ensure a transparent and worry-free journey."
    },
    {
        "WhyChooseheading": "Customizable Travel Plans and Stopovers",
        "WhyChoosedescription": "Customize your Pune to Mumbai route with optional stopovers, flexible pickup/drop-off locations, and travel time preferences—all while booking online. We put you in control of your itinerary with just a few clicks."
    },
    {
        "WhyChooseheading": "24/7 Online Support and Booking Assistance",
        "WhyChoosedescription": "Need help while booking? Our dedicated online support team is available round-the-clock to assist you with vehicle selection, fare estimates, rescheduling, cancellations, or any special requests, ensuring a smooth booking experience from start to finish."
    },
    {
        "WhyChooseheading": "Safe, Reliable, and Verified Drivers",
        "WhyChoosedescription": "All online bookings come with background-verified, experienced drivers who prioritize your safety and comfort. Enjoy a secure trip with professional chauffeurs trained in intercity travel between Pune and Mumbai."
    }
]


















    }

const faqData = [
    {
        question: "How can I book a cab online from Pune to Mumbai with Meghana Cab?",
        answer: "You can book online easily by visiting our website or calling us at +91 9075462128 for instant confirmation and support."
    },
    {
        question: "Is online cab booking available 24/7?",
        answer: "Yes, our online booking system is available 24/7, allowing you to schedule your cab at any time, day or night."
    },
    {
        question: "Can I select the vehicle type while booking online?",
        answer: "Yes, you can choose from hatchbacks, sedans, SUVs, and tempo travellers based on your group size and comfort preferences."
    },
    {
        question: "Will I get booking confirmation immediately?",
        answer: "Yes, you will receive instant confirmation via SMS or email once your booking is successful."
    },
    {
        question: "Do I need to make an advance payment for online booking?",
        answer: "A small advance payment may be required to confirm your booking, especially during peak hours or holidays."
    },
    {
        question: "Can I modify or cancel my online booking?",
        answer: "Yes, bookings can be modified or cancelled by contacting our customer support. Cancellation charges may apply as per policy."
    },
    {
        question: "Is the online booking platform secure for payments?",
        answer: "Absolutely. Our online system uses secure payment gateways to ensure safe and encrypted transactions."
    },
    {
        question: "What happens after I book a cab online?",
        answer: "You will receive driver details, vehicle number, and tracking info shortly before your scheduled pickup time."
    },
    {
        question: "Can I book a cab online for immediate pickup?",
        answer: "Yes, subject to availability. For urgent bookings, we recommend calling us directly for faster confirmation."
    },
    {
        question: "Are there any discounts for booking online?",
        answer: "Yes, we often provide exclusive offers and promo codes for online bookings. Check our website or call for current deals."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Harshal Pawar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The online booking process was super easy and quick. Driver arrived on time and the ride to Mumbai was very comfortable.”',
    },
    {
        name: 'Ms. Rutuja Shinde',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked online with Meghana Cab—got instant confirmation and great service. Will definitely book again for my next trip.”',
    },
];

















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Online Cab Booking",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-mumbai-online-cab-booking.jpg",
  "description": "Book a cab online from Pune to Mumbai with Meghana Cabs. Enjoy instant booking, 24/7 availability, and secure online payments. Choose from AC Sedans, SUVs, and chauffeur-driven cars for one way or round trips.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1799",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-mumbai-online-cab-booking"
  }
};








    return (
        <div>

<Helmet>
  <title>Pune to Mumbai Online Cab Booking | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book your Pune to Mumbai cab online with Meghana Cabs. Secure and fast reservations for AC Sedans, SUVs, and chauffeur-driven cars. 24/7 availability for one way and round trips. Instant confirmation." 
  />
  <meta 
    name="keywords" 
    content="Online Booking Cab Pune to Mumbai, Book Cab Online Pune to Mumbai, Fast Cab Reservation Pune to Mumbai, One Way Online Cab Pune to Mumbai, Round Trip Online Booking Pune Mumbai, 24/7 Cab Booking Site Pune to Mumbai, App Booking Cab Pune to Mumbai, Secure Online Taxi Booking Pune Mumbai, Sedan Booking Online Pune to Mumbai, SUV Online Booking Pune to Mumbai, Quick Cab Online Booking Pune Mumbai Route, Chauffeur Booking Pune Mumbai Cab, Private Taxi Online Booking Pune to Mumbai, Budget Online Cab Hire Pune Mumbai, Instant Booking Cab Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/76.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaionlinecabbooking;